import React, {Component} from 'react';
import UserGroupAttributesTable from "./UserGroupAttributesTable";
import {PropTypes} from 'prop-types';

class UserGroupAttributes extends Component {
  static propTypes = {
    userGroupAttributes: PropTypes.any,
    capabilitiesMappingId: PropTypes.string,
    handleAddUserGroupAttribute: PropTypes.func,
    handleDelUserGroupAttribute: PropTypes.func,
    handleUpdateUserGroupAttributes: PropTypes.func,
  }

  static defaultProps = {
    capabilitiesMappingId: "UserGroupAttributes"
  };
  handleAddEvent = () => {
    this.props.handleAddUserGroupAttribute();
  }
  handleDelEvent = (target) => {
    this.props.handleDelUserGroupAttribute(target);
  }
  handleUserGroupAttributesTable = (evt) => {
    this.props.handleUpdateUserGroupAttributes(evt);
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {idpUserGroupAttributes} = this.props;
    return (
        <div className="pt-31">
          <UserGroupAttributesTable
              onUserGroupAttributesTableUpdate={this.handleUserGroupAttributesTable}
              displayUserGroupAttributes={this.props.displayUserGroupAttributes}
              onRowAdd={this.handleAddEvent}
              onRowDel={this.handleDelEvent}
              UserGroupAttributes={idpUserGroupAttributes}/>
        </div>
    );
  }
}

export default UserGroupAttributes;







// WEBPACK FOOTER //
// ./src/components/AddSAML/UserGroupAttributes/UserGroupAttributes.js